import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import {
  StyledContainer,
  StyledHeader,
  StyledWrapper
} from './DurationAndCosts.styled';
import FeesByRole from './FeesByRole';

const Fees: React.FC = () => {
  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledHeader>
          <Heading2 editorial>
            <HtmlTrans
              i18nKey="state-of-hiring.fees.title"
              ns="state-of-hiring"
            />
          </Heading2>
          <div>
            <HtmlTrans
              i18nKey="state-of-hiring.fees.desc"
              ns="state-of-hiring"
            />
          </div>
        </StyledHeader>
        <FeesByRole />
      </StyledContainer>
    </StyledWrapper>
  );
};

export default Fees;
